import { Injectable } from '@angular/core';
import { OmniPagamentoFlexivelService } from './../../omni-rest/omni-parametro-flexivel/omni-pagamento-flexivel.service';
import { Observable } from 'rxjs';
import {ParametroParcelaResponse } from './parametro-parcela-response.interface';

@Injectable()
export class ParametroParcelaService {

  constructor(
    private omniPagamentoFlexivelService: OmniPagamentoFlexivelService,
  ){}
      
  getParametroParcela(): Observable<ParametroParcelaResponse> {
    return this.omniPagamentoFlexivelService.get('parcel-parameter');
  }

}